import { Heading, Icon } from "@amzn/storm-ui";
import { sparkle } from "@amzn/storm-ui-icons";
import React from "react";

import { CardDetailsSource } from "../../types/card";
import { CardDetails } from "../discovery/insights/insightDetails/CardDetails";
import {
    StyledDetailSheetDetailsContainer,
    StyledDetailSheetTitleContainer,
    StyledSummaryHeader,
} from "../discovery/insights/insightDetails/styles";

import { ComponentLabel } from "./styled.components";

const formatAiSummary = (summary: string): string =>
    summary.replace(/\s*•\s*/g, "\n• ") +
    "\n\nDisclaimer: This summary is AI generated. Please review before use.";

export const AISummarySection: React.FunctionComponent<{
    aiSummaryOverview: string | undefined;
    aiSummaryExecutive: string | undefined;
    contentId?: string;
    contentType?: string;
    logExpandClick?: boolean;
    dataTestId?: string;
}> = ({
    aiSummaryOverview,
    aiSummaryExecutive,
    contentId,
    contentType,
    logExpandClick,
    dataTestId,
}) => (
    <>
        <StyledDetailSheetTitleContainer>
            <Heading
                renderAs="h5"
                size="small"
                typeface="ember"
                data-testid={dataTestId}
            >
                {aiSummaryOverview ?? ""}
            </Heading>
        </StyledDetailSheetTitleContainer>
        {aiSummaryExecutive && (
            <StyledDetailSheetDetailsContainer>
                <StyledSummaryHeader>
                    <ComponentLabel>Summary</ComponentLabel>
                    <Icon size="s" type={sparkle} />
                </StyledSummaryHeader>
                <CardDetails
                    details={[
                        {
                            label: "",
                            value: formatAiSummary(aiSummaryExecutive),
                            lineClamp: 4,
                            expandable: true,
                            showTooltip: false,
                            ...(logExpandClick && { logExpandClick: true }),
                            ...(contentId && { contentId }),
                            ...(contentType && { contentType }),
                        },
                    ]}
                    source={CardDetailsSource.SIDEPANEL}
                />
            </StyledDetailSheetDetailsContainer>
        )}
    </>
);
